import React from 'react'
import styled from '@emotion/styled'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {cssTheme} from '@vio/atlas/themes'
import {Offer} from '@vio/core/src/offer/types/offer'
import {Room, SplitBooking} from '@vio/core/src/room/types/room'

import {RoomOfferDealFreezeCTA} from './RoomOfferDealFreezeCTA'
import {RoomOfferRegularCTA} from './RoomOfferRegularCTA'

type Props = {
  hotelId: string
  room?: Room
  offer?: Offer
  splitBooking?: SplitBooking
  component: string
  // isCompactLayout: If true - aligns items in a row instead of columns
  isCompactLayout?: boolean
  shouldShowDealFreezeButton?: boolean
}

const ColumnCTALayout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s300};
`
/**
 * - Items are aligned in row-reverse direction
 * - When there's only one item - it's taking min 50% of the width
 * - When there's two items - they're taking 50% of the width each
 *   - when content of one of the items takes more than 50%
 *     items switch to column layout and take 100% of width
 */
const RowCTALayoutWithWrap = styled.div`
  display: flex;
  width: 100%;
  white-space: nowrap;
  flex-direction: row-reverse;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: ${cssTheme.layout.spacing.s300};
  .--cta-item {
    flex: 1 0 calc(50% - ${cssTheme.layout.spacing.s300} / 2);
    &:only-child {
      flex-grow: 0;
    }
  }
`

export const RoomOfferCTA = ({
  hotelId,
  room,
  offer,
  splitBooking,
  component,
  shouldShowDealFreezeButton = false
}: Props) => {
  const {isMobile} = useDeviceLayout()
  const CtaLayout = isMobile ? RowCTALayoutWithWrap : ColumnCTALayout

  return (
    <CtaLayout>
      <div className="--cta-item">
        <RoomOfferRegularCTA
          hotelId={hotelId}
          room={room}
          offer={offer}
          splitBooking={splitBooking}
          component={component}
        />
      </div>
      {shouldShowDealFreezeButton && (
        <div className="--cta-item">
          <RoomOfferDealFreezeCTA hotelId={hotelId} room={room} offer={offer} />
        </div>
      )}
    </CtaLayout>
  )
}
